import { faBalanceScaleRight } from '@fortawesome/pro-light-svg-icons/faBalanceScaleRight';

import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit, ChangeDetectionStrategy, EventEmitter, Output, ViewChild } from '@angular/core';
import { CdkOverlayOrigin, OverlayModule } from '@angular/cdk/overlay';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { UserMenu } from '../../user/user-menu';
import { MenuService } from '../menu.service';
import { LoggerService } from '../logger.service';
import { Constants } from '../constants';

import { faHome } from '@fortawesome/pro-light-svg-icons/faHome';
import { faBuilding } from '@fortawesome/pro-light-svg-icons/faBuilding';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { faFileContract } from '@fortawesome/pro-light-svg-icons/faFileContract';
import { faShovel } from '@fortawesome/pro-light-svg-icons/faShovel';
import { faForklift } from '@fortawesome/pro-light-svg-icons/faForklift';
import { faCalculatorAlt } from '@fortawesome/pro-light-svg-icons/faCalculatorAlt';
import { faCalculator } from '@fortawesome/pro-light-svg-icons/faCalculator';
import { faRecycle } from '@fortawesome/pro-light-svg-icons/faRecycle';
import { faUserTag } from '@fortawesome/pro-light-svg-icons/faUserTag';
import { faHandsUsd } from '@fortawesome/pro-light-svg-icons/faHandsUsd';
import { faUser } from '@fortawesome/pro-light-svg-icons/faUser';
import { faAnalytics } from '@fortawesome/pro-light-svg-icons/faAnalytics';
import { faEllipsisHAlt } from '@fortawesome/pro-light-svg-icons/faEllipsisHAlt';
import { faLeaf } from '@fortawesome/pro-light-svg-icons';
import { faFileChartPie } from '@fortawesome/pro-light-svg-icons/faFileChartPie';
import { faLink } from '@fortawesome/pro-light-svg-icons/faLink';
import { faBooks } from '@fortawesome/pro-light-svg-icons/faBooks';
import { faUsdSquare } from '@fortawesome/pro-light-svg-icons/faUsdSquare';
import { faStream } from '@fortawesome/pro-light-svg-icons/faStream';
import { faQuestionSquare } from '@fortawesome/pro-light-svg-icons/faQuestionSquare';
import { faHandshake, faFileCircleCheck, faCodeCompare, faChartMixed } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgIf } from '@angular/common';

@Component({
  selector: 'cub-left-menu-button',
  templateUrl: './left-menu-button.component.html',
  styleUrls: ['./left-menu-button.component.scss'],
  animations: [
    trigger('showingListing', [
      state('true', style({
        transform: 'rotate(0)'
      })),
      state('false', style({
        transform: 'rotate(90deg)'
      })),
      transition('true => false', animate('500ms ease-in')),
      transition('false => true', animate('500ms ease-out'))
    ])
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgIf, RouterLinkActive, RouterLink, FontAwesomeModule, OverlayModule]
})
export class LeftMenuButtonComponent implements OnInit {

  @Input() menuItem: UserMenu;
  @Input() expanded = false;
  @Input() selected = false;
  @Output() menuRequested = new EventEmitter<CdkOverlayOrigin>();
  @Output() menuHovered = new EventEmitter<CdkOverlayOrigin>();
  @Output() menuLeft = new EventEmitter<void>();
  @Output() menuClosed = new EventEmitter<void>();
  @ViewChild(CdkOverlayOrigin) origin: CdkOverlayOrigin;
  showSystemList = true;
  minMaxLeftMenu: boolean;
  screenWidth: number;

  faHome = faHome;
  faBuilding = faBuilding;
  faChevronRight = faChevronRight;


  constructor(
    private router: Router,
    private loggerService: LoggerService,
    private menuService: MenuService
  ) {
    this.screenWidth = (window.innerWidth);
  }

  ngOnInit() {
    this.menuService.showingSystemMenu$.subscribe(result => {
      this.showSystemList = result;
    });
  }

  menuClick() {
    this.menuRequested.emit(this.origin);
    this.loggerService.logPageVisit('left menu clicked', this.menuItem.name);
  }

  onPointerEnter(event: PointerEvent): void {
    if (event.pointerType === 'mouse') {
      this.menuHovered.emit(this.origin);
    }
  }

  onPointerLeave(event: PointerEvent): void {
    if (event.pointerType === 'mouse') {
      this.menuLeft.emit();
    }
  }

  hideMenu() {
    this.loggerService.logPageVisit('left menu clicked', this.menuItem.name);
    this.menuClosed.emit();
    if (this.screenWidth <= Constants.ResponsiveWidthTrigger) {
      this.menuService.toggleLeftMenu(false);
    }
  }

  toggleSystemList(): void {
    this.menuService.toggleSystemMenu(!this.showSystemList);
  }

  getIcon(icon: string): any {
    let fa = faHome;
    switch (icon) {
      case 'faHome':
        fa = faHome;
        break;
      case 'faBuilding':
        fa = faBuilding;
        break;
      case 'faFileContract':
        fa = faFileContract;
        break;
      case 'faShovel':
        fa = faShovel;
        break;
      case 'faForklift':
        fa = faForklift;
        break;
      case 'faCalculator':
        fa = faCalculator;
        break;
      case 'faRecycle':
        fa = faRecycle;
        break;
      case 'faUserTag':
        fa = faUserTag;
        break;
      case 'faHandsUsd':
        fa = faHandsUsd;
        break;
      case 'faUser':
        fa = faUser;
        break;
      case 'faAnalytics':
        fa = faAnalytics;
        break;
      case 'faEllipsisHAlt':
        fa = faEllipsisHAlt;
        break;
      case 'faLeaf':
        fa = faLeaf;
        break;
      case 'faFileChartPie':
        fa = faFileChartPie;
        break;
      case 'faLink':
        fa = faLink;
        break;
      case 'faBooks':
        fa = faBooks;
        break;
      case 'faUsdSquare':
        fa = faUsdSquare;
        break;
      case 'faQuestionSquare':
        fa = faQuestionSquare;
        break;
      case 'faHandshake':
        fa = faHandshake;
        break;
      case 'faFileCircleCheck':
        fa = faFileCircleCheck;
        break;
      case 'faCodeCompare':
        fa = faCodeCompare;
        break;
      case 'faChartMixed':
        fa = faChartMixed;
        break;
      case 'faStream':
        fa = faStream;
        break;
      default:
        break;
    }
    return fa;
  }

  goToUrl(url: string, localRoute: boolean): void {
    let newUrl = url;
    if (document.location.href.startsWith('https')) {
      newUrl = url.replace('http://cub/', 'https://cub.centerpoint.com/');
      newUrl = newUrl.replace('http://cubapi/', 'https://cub.centerpoint.com/');
    }
    if (localRoute) {
      this.router.navigate([newUrl]);
    } else {
      window.open(newUrl, '_blank', 'noopener');
    }
  }
}
